import { hasSession } from "@mobsuccess-devops/react-shared/auth";
import { getWorkspace } from "@mobsuccess-devops/react-shared/workspace";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { RootPending } from "@/components/RootPending";
import { AppLayout } from "@/views/app/layout";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad({ context, search }) {
    if (!hasSession(context.queryClient)) {
      throw redirect({ to: "/sign-in", search, replace: true });
    }
  },
  // Loader data, not beforeLoad context: the context is rebuilt on every
  // navigation and is briefly empty for the screens already mounted, whereas
  // loader data stays put.
  async loader({ context }) {
    const { user, sidebar, webapps } = await getWorkspace(
      context.queryClient,
      "auth",
    );
    return { user, sidebar, webapps };
  },
  pendingComponent: RootPending,
  component: AppLayout,
});
